import { Typography } from '@mui/material';
import { Spacer as BlockheadSpacer } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Spacer = styled(BlockheadSpacer).attrs({
  space: '16px',
  orientation: 'vertical',
})`
  width: 100%;
`;

export const Title = styled(Typography).attrs({
  variant: 'h1',
})`
  width: 100%;
`;
